export const assert = (condition: boolean, message: string): void => {
  if (process.env.NODE_ENV !== "production") {
    if (!condition) {
      throw new Error(message);
    }
  }
};

export const warn = (message: string): void => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(message);
  }
};
